import { gql } from 'apollo-angular';
import DocumentVersionNote from '../../../../interfaces/document-version-note';
import ID from '../../../../types/id';

type CreateDocumentVersionNoteResults = {
  createDocumentVersionNote: DocumentVersionNote;
};
type CreateDocumentVersionNoteVariables = {
  input: {
    document_version_id: ID;
    note_text: string;
    user_id: ID;
  };
};

export const CREATE_NOTE = gql<
  CreateDocumentVersionNoteResults,
  CreateDocumentVersionNoteVariables
>`
  mutation createDocumentNote($input: CreateDocumentVersionNoteInput) {
    createDocumentVersionNote(input: $input) {
      id
      document_version_id
      note_text
      user {
        id
        person {
          id
          name
        }
      }
      documentVersion {
        id
        document {
          id
        }
      }
      created
      modified
    }
  }
`;

type UpdateDocumentVersionNoteResults = {
  updateDocumentVersionNote: DocumentVersionNote;
};
type UpdateDocumentVersionNoteVariables = {
  id: ID;
  input: {
    note_text: string;
  };
};
export const UPDATE_NOTE = gql<
  UpdateDocumentVersionNoteResults,
  UpdateDocumentVersionNoteVariables
>`
  mutation updateDocumentNote(
    $id: ID!
    $input: UpdateDocumentVersionNoteInput!
  ) {
    updateDocumentVersionNote(id: $id, input: $input) {
      id
      document_version_id
      note_text
      user {
        id
        person {
          id
          name
        }
      }
      created
      modified
    }
  }
`;

type DeleteDocumentVersionNoteResults = {
  deleteDocumentVersionNote: DocumentVersionNote;
};
type DeleteDocumentVersionNoteVariables = {
  id: ID;
};

export const DELETE_NOTE = gql<
  DeleteDocumentVersionNoteResults,
  DeleteDocumentVersionNoteVariables
>`
  mutation deleteDocumentNote($id: ID!) {
    deleteDocumentVersionNote(id: $id) {
      id
    }
  }
`;
